import type { ValueOf } from 'cpool-utils';

export const WHATSAPP_TEMPLATE_PICKER_TABS = {
    QUICK_REPLIES: 'quick_replies',
    TEMPLATES: 'templates',
} as const;

export type WhatsAppTemplatePickerTab = ValueOf<typeof WHATSAPP_TEMPLATE_PICKER_TABS>;

export const CHIP_PLACEHOLDER_VARIANTS = {
    DEFAULT: 'default',
    ERROR: 'error',
} as const;

export type ChipPlaceholderVariant = ValueOf<typeof CHIP_PLACEHOLDER_VARIANTS>;

// Chip composer: py-2 is inside max-height, so padding must be added or N "lines" is a lie.
export const TEMPLATE_COMPOSER_MAX_LINES = 12;
export const TEMPLATE_COMPOSER_LINE_HEIGHT_PX = 20;
export const TEMPLATE_COMPOSER_VERTICAL_PADDING_PX = 16;
export const TEMPLATE_COMPOSER_BORDER_PX = 2;
export const TEMPLATE_COMPOSER_MIN_HEIGHT_PX =
    TEMPLATE_COMPOSER_LINE_HEIGHT_PX + TEMPLATE_COMPOSER_VERTICAL_PADDING_PX + TEMPLATE_COMPOSER_BORDER_PX;
export const TEMPLATE_COMPOSER_MAX_HEIGHT_PX =
    TEMPLATE_COMPOSER_MAX_LINES * TEMPLATE_COMPOSER_LINE_HEIGHT_PX + TEMPLATE_COMPOSER_VERTICAL_PADDING_PX;

// Overlay sits above the composer. h-80 (320px) left ~180px for the list after
// header/tabs/search — not enough for a typical greeting preview.
export const TEMPLATE_PICKER_OVERLAY_HEIGHT_CLASS = 'h-[min(28rem,70vh)]';
